import React, { useState, useEffect } from 'react';

import './styles.css';

import { FaInfo, FaTimes } from 'react-icons/fa';

function Popup(props) {
    const [visible, setVisible] = useState(props.visibility);

    useEffect(() => {
        setVisible(props.visibility)
    }, [props.visibility]);

    return (
        <div className={'popup' + (visible ? '' : ' hide') + (props.className ? ` ${props.className}` : "")} id={props.id}>
            <div className='popup-component'>
                <div className="popup-component-header">
                    <div className="popup-component-header-tittle">
                        {props.icon ? props.icon : <FaInfo />}
                        <h5 className='tittle'>{props.tittle ? props.tittle : 'Pop-up'}</h5>
                    </div>
                    <button type="button" onClick={() => props.setVisibility(false)}>
                        <FaTimes />
                    </button>
                </div>
                <div className="popup-component-content">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export default Popup;